// Keeps a crash inside the help layer from taking the game down with it. The
// help UI is an overlay: if it breaks, the screen underneath must keep
// working, so the fallback is nothing at all (the error still reaches Sentry
// through the console and the global handler).
import { Component } from 'react';

export default class HelpErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error('[session-help] overlay crashed', error);
  }

  componentDidUpdate(prevProps) {
    // A new session (or a route change the parent keys on) gets a fresh try.
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
